export default {"src":"/_next/static/media/sand-clock.d1b3eb0a.svg","height":21,"width":21,"blurWidth":0,"blurHeight":0};